import React, { useState, useEffect } from 'react'
import './styles.scss'
import Heading from '../heading/Heading'
import LeasingRateBox from '../leasing-rate-box/LeasingRateBox';
import { useSelector, useDispatch } from 'react-redux'
import phoneIco from './../../images/phone-ico.svg'
import checkNaN from '../../services/checkNaN';
import formatPrice from '../../services/formatPrice';


const LeasingRate = ( props ) => {
    let callNumber = useSelector(state => state.callNumber);
    
    let activeContract = useSelector(state => state.selectedLease); 
    let isShop = useSelector(state => state.isShop); 
    

    return (
        <>
        
            <>
            { !isShop && 
                    <div className="call-box">
                        { callNumber && 
                            <>
                                <div className="icon">
                                    <img src={ phoneIco } alt="Zadzwoń"/>
                                </div>
                                <div className="text">
                                    <p>W przypadku pytań zadzwoń do GRENKE</p>
                                    <a href={"tel:" + callNumber.replace('/', '')}>{ callNumber }</a>
                                    <span>pn. – pt.  8.00 – 16.00</span>
                                </div>
                            </>
                        }
                    </div>
            }
            <div className={"leasing-rate " + (isShop ? 'shop' : '') }>
                <div className="wrap">
                <div className="shadow-box">
                    <Heading title="Kalkulacja opłat"
                             tip={ true } 
                             tipHeader="Kalkulacja opłat"
                             tipText={ activeContract === 'tradycyjny' ? 'Liczba rat skalkulowana dla Podstawowego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego miesiąca (jeśli uzgodniono miesięczną płatność rat) lub kwartału (jeśli uzgodniono kwartalną płatność rat) następującego po dacie odbioru Przedmiotu Najmu. Za każdy dzień poprzedzający Podstawowy Okres Umowy, Najemca zobowiązany jest zapłacić wynagrodzenie w wysokości 1/30 raty (jeśli uzgodniono miesięczną płatność rat) albo 1/90 raty (jeśli uzgodniono kwartalną płatność rat).' : 'Liczba rat skalkulowana dla Minimalnego Okresu Umowy, który zaczyna się od pierwszego dnia kolejnego miesiąca (jeśli uzgodniono miesięczną płatność rat) lub kwartału (jeśli uzgodniono kwartalną płatność rat) następującego po dacie odbioru Przedmiotu Najmu. Za każdy dzień poprzedzający Minimalny Okres Umowy, Najemca zobowiązany jest zapłacić wynagrodzenie w wysokości 1/30 raty (jeśli uzgodniono miesięczną płatność rat) albo 1/90 raty (jeśli uzgodniono kwartalną płatność rat).'}
                    />
                    
                    <LeasingRateBox textRate="Rata kwartalna (4 raty w roku)"
                        price4={ props.rate4 }
                        price12={ props.rate12 }
                        text="Do powyższych kwot należy doliczyć podatek VAT. Niniejsza kalkulacja ma jedynie charakter informacyjny i nie stanowi oferty w rozumieniu Kodeksu Cywilnego." 
                        activeRate4={ props.activeRate4 } 
                        changePage={ () => props.changePage() } 
                        forceValidate={ props.forceValidate } />
                </div>
            </div>
        </div>
        </>
        {/* } */}
        </>
    )
}

export default LeasingRate;